export const enableMocking = async () => {
	if (import.meta.env.VITE_API_MOCKING !== "enabled") {
		return;
	}

	try {
		const { worker } = await import("@/mocks/browser");

		await worker.start({
			onUnhandledRequest: "bypass",
		});
	} catch (error) {
		console.error(error);
	}
};
